import { jsx as _jsx } from "react/jsx-runtime";
import EditorWorkspace from 'components/EditorWorkspace';
import { useWorkspace } from 'features/workspace/context';
export default function EditorRoute() {
    const { quickLinks } = useWorkspace();
    const links = quickLinks.filter((link) => link.category === 'editor' || link.category === 'dashboard');
    return _jsx(EditorWorkspace, { links: links });
}
